export default "__VITE_ASSET__CykWlbue__"